import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { BdsButton, BdsIcon } from '@/core/constants/webComponents';
import './CreateFileConfirmationModal.scss';

interface CreateFileConfirmationModalProps {
  fileName: string;
  postsCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export const CreateFileConfirmationModal: React.FC<CreateFileConfirmationModalProps> = ({
  fileName,
  postsCount,
  onCancel,
  onConfirm,
}) => {
  const { t, i18n } = useTranslation();

  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    globalThis.addEventListener('keydown', handleKeyDown);
    return () => globalThis.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  return (
    <dialog
      className="create-file-confirmation-modal"
      aria-modal="true"
      aria-labelledby="confirm-modal-title"
    >
      <div className="create-file-confirmation-modal__card">
        <div className="create-file-confirmation-modal__header">
          <BdsIcon name="warning" class="create-file-confirmation-modal__icon" />
          <span className="create-file-confirmation-modal__title" id="confirm-modal-title">
            {t('file.confirmModalTitle')}
          </span>
        </div>
        <div className="create-file-confirmation-modal__content">
          <p className="create-file-confirmation-modal__message">
            <Trans
              i18nKey="file.confirmModalMessage"
              values={{
                postsCount: postsCount.toLocaleString(i18n.language),
                fileName,
              }}
              components={{ b: <b /> }}
            />
          </p>
          <p className="create-file-confirmation-modal__secondary-message">
            {t('file.confirmModalSecondaryMessage')}
          </p>
        </div>
        <div className="create-file-confirmation-modal__footer">
          <BdsButton variant="text" color="content" onClick={onCancel}>
            {t('file.confirmModalNo')}
          </BdsButton>
          <BdsButton variant="primary" onClick={onConfirm}>
            {t('file.confirmModalYes')}
          </BdsButton>
        </div>
      </div>
    </dialog>
  );
};
